var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1698 5.45919L12.199 8.1019C10.9272 11.5674 10.2913 13.3001 9.0364 14.5646C7.7815 15.8291 6.06189 16.4698 2.62268 17.7514L0 18.7296L2.62268 19.7078C6.06189 20.9894 7.7815 21.632 9.0364 22.8946C10.2913 24.1572 10.9272 25.8918 12.199 29.3573L13.1698 32L14.1407 29.3573C15.4125 25.8918 16.0503 24.1591 17.3033 22.8946C18.5563 21.6301 20.2778 20.9894 23.717 19.7078L26.3397 18.7296L23.717 17.7514C20.2778 16.4698 18.5582 15.8291 17.3033 14.5646C16.0484 13.3001 15.4125 11.5674 14.1407 8.1019L13.1698 5.45919ZM26.3558 0L25.94 1.13178C25.3944 2.61806 25.1216 3.3612 24.5854 3.9015C24.0473 4.44369 23.3098 4.71858 21.8348 5.26646L20.7116 5.68732L21.8366 6.10628C23.3098 6.65606 24.0473 6.93094 24.5835 7.47124C25.1216 8.01343 25.3944 8.75657 25.9381 10.2429L26.3558 11.3746L26.7716 10.2429C27.3172 8.75657 27.59 8.01343 28.1262 7.47313C28.6643 6.93094 29.4018 6.65606 30.8768 6.10818L32 5.68732L30.8749 5.26835C29.4018 4.71858 28.6643 4.44369 28.1281 3.9034C27.59 3.3612 27.3172 2.61806 26.7735 1.13178L26.3558 0Z",
    fill: "url(#paint0_linear_25_60)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_60",
    x1: 8.16088e-8,
    y1: 40.5333,
    x2: 33.7238,
    y2: 40.1309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0427C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916586,
    stopColor: "#BF05CF",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.44c731198357bae3c748ee750931ddd6.svg";
export { ForwardRef as ReactComponent };